import React from 'react';
import {
  DatePicker,
} from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

function ManualEntryDatePicker({
  value,
  onChange,
  allowFuture = false,
  allowClear = false,
  style = {},
  format = 'YYYY-MM-DD',
}) {
  const momentValue = value ? moment(value) : null;
  const onDateChange = (momentInstance) => {
    onChange(momentInstance?.format(format) ?? null);
  };

  return (
    <DatePicker
      disabledDate={allowFuture ? null : (current) => current > moment()}
      allowClear={allowClear}
      value={momentValue}
      onChange={onDateChange}
      style={style}
    />
  );
}

ManualEntryDatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  allowFuture: PropTypes.bool,
  allowClear: PropTypes.bool,
  style: PropTypes.object,
  format: PropTypes.string,
};

ManualEntryDatePicker.defaultProps = {
  value: undefined,
  allowFuture: false,
  allowClear: false,
  style: {},
  format: 'YYYY-MM-DD',
};

export default ManualEntryDatePicker;
